import React, { useEffect, useState, useMemo } from "react"
import { Table, Row, Col, Input, Modal, Form, Label } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import { getContractServiceColumns } from "../../../utils/columns/settings/contractCols"

// common
import Pagination from "components/Common/Pagination"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Loader from "pages/Separate/Loader"
import Swal from "sweetalert2"

function TableContainer({ columns, data, setAddStatus, setEditStatus }) {
  const [fixedContent, setFixedContent] = useState(false)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    setFixedContent(window.scrollY > 165)
  })

  const navigate = useNavigate()

  return (
    <div className="px-2">
      <div
        className={`flex-column fixed-buttons ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <button
          onClick={() => setAddStatus(true)}
          className="btn btn-purple border-radius fix-btn"
        >
          <i className="fas fa-plus me-2"></i>
          <span>Contract Service</span>
        </button>
        <a
          onClick={() => navigate(-1)}
          className="btn btn-red border-radius fix-btn"
        >
          <i className="dripicons-cross me-2 icon-center"></i>
          <span>Cancel</span>
        </a>
      </div>

      <Row className="mb-2">
        <Col lg={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 30, 40, 50].map(size => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            <a
              className="border-radius btn btn-purple"
              onClick={() => setAddStatus(true)}
            >
              <i className="fas fa-plus me-2 icon-size"></i>Add Contract Service
            </a>
            <a
              className="border-radius btn text-white ms-md-2 btn-red"
              onClick={() => navigate(-1)}
            >
              <i className="dripicons-cross me-2 icon-center"></i>Cancel
            </a>
          </div>
        </Col>
      </Row>

      <Table className="table table-bordered mt-4" {...getTableProps()}>
        <thead className={`${fixedContent ? "fixed-setting-header" : ""}`}>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={index}
                  className={`col-md-${index === 0 ? "1" : index === 1 ? "9" : "2"
                    }`}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="row-hover" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => (
                  <td
                    className={`col-md-${index === 0 ? "1" : index === 1 ? "9" : "2"
                      }`}
                    key={index}
                    {...cell.getCellProps()}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  )
}

const ContractService = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [addStatus, setAddStatus] = useState(false)
  const [editStatus, setEditStatus] = useState(false)
  const [contractService, setContractService] = useState("")
  const [editId, setEditId] = useState(null)

  const getData = async () => {
    const response = await fetchNodeData(
      setLoading,
      "getContract/contract-services",
      secureLocalStorage?.getItem("auth_token")
    )
    setData(response.data)

  }

  useEffect(() => {
    getData()
  }, [])

  const updateService = (id, service) => {
    setContractService(service)
    setEditId(id)
    setEditStatus(true)
  }

  const deleteContractService = async id => {
    const token = secureLocalStorage?.getItem("auth_token")

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const res = await fetchNodeData(
            setLoading,
            `deleteContract/contract-services/${id}`,
            token
          )
          if (res.status === 200) {
            Swal.fire({
              icon: "success",
              text: "Contract Service Deleted Successfully",
              showConfirmButton: true,
            })
            setData(res.data)
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed!",
              text: res.data.message,
            })
          }
        } catch (err) {
          console.error("Error during delete:", err)
          Swal.fire({
            icon: "error",
            text: "An error occurred while deleting the contract service",
            showConfirmButton: true,
          })
        }
      }
    })
  }

  const handleAddSubmit = async () => {
    try {
      let formData = {
        service: contractService,
      }
      const token = secureLocalStorage?.getItem("auth_token")
      const res = await FetchNodePostData(
        setLoading,
        "postContract/contract-services",
        token,
        formData
      )

      if (res.status === 200) {
        setAddStatus(false)
        setData(res.data.data)
        setContractService("")
        Swal.fire({
          icon: "success",
          text: "Contract Service Added Successfully",
          showConfirmButton: true,
        })
      } else {
        Swal.fire({
          icon: "error",
          text: res.data.message,
          showConfirmButton: true,
        })
      }
    } catch (err) {
      console.error("Error during add:", err)
      Swal.fire({
        icon: "error",
        text: "An error occurred while adding the contract service",
        showConfirmButton: true,
      })
    }
  }

  const handleEditSubmit = async () => {
    try {
      let formData = {
        id: editId,
        service: contractService,
      }
      const token = secureLocalStorage?.getItem("auth_token")
      const res = await FetchNodePostData(
        setLoading,
        "putContract/contract-services",
        token,
        formData
      )

      if (res.status === 200) {
        setEditStatus(false)
        setData(res.data.data)
        setContractService("")
        Swal.fire({
          icon: "success",
          text: "Contract Service Updated Successfully",
          showConfirmButton: true,
        })
      } else {
        Swal.fire({
          icon: "error",
          text: res.data.message,
          showConfirmButton: true,
        })
      }
    } catch (err) {
      console.error("Error during update:", err)
      Swal.fire({
        icon: "error",
        text: "An error occurred while updating the contract service",
        showConfirmButton: true,
      })
    }
  }

  const columns = useMemo(
    () => getContractServiceColumns(updateService, deleteContractService),
    []
  )

  return (
    <div>
      {loading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <div className="responsive-table">
            <TableContainer
              columns={columns}
              data={data}
              setAddStatus={setAddStatus}
              setEditStatus={setEditStatus}
              loading={loading}
            />
          </div>
        </Col>

        {/* Add Modal */}
        <Modal isOpen={addStatus} size="sm" className="bd-custom-md-3" centered>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Add Contract Service</h5>
            <button
              type="button"
              onClick={() => {
                setAddStatus(false)
                setContractService("")
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                ×
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form className="row">
              <div className="mb-3 col-md-12">
                <Label htmlFor="formrow-firstname-Input">
                  Contract Service
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="formrow-firstname-Input"
                  placeholder="Enter Contract Service"
                  value={contractService}
                  onChange={e => setContractService(e.target.value)}
                />
              </div>
              <div className="mt-20">
                <button
                  type="button"
                  className="border-radius btn btn-purple"
                  onClick={handleAddSubmit}
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>

        {/* Edit Modal */}
        <Modal
          isOpen={editStatus}
          size="sm"
          className="bd-custom-md-3"
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">Edit Contract Service</h5>
            <button
              type="button"
              onClick={() => {
                setEditStatus(false)
                setContractService("")
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                ×
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form className="row">
              <div className="mb-3 col-md-12">
                <Label htmlFor="formrow-firstname-Input">
                  Contract Service
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="formrow-firstname-Input"
                  placeholder="Enter Contract Service"
                  value={contractService}
                  onChange={e => setContractService(e.target.value)}
                />
              </div>
              <div className="mt-20">
                <button
                  type="button"
                  className="border-radius btn btn-purple"
                  onClick={handleEditSubmit}
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </Modal>
      </Row>
    </div>
  )
}

export default ContractService
